import React, { Component } from "react";
import ReactGA from "react-ga";
import Moment from "react-moment";

import firebase from "firebase/app";
import "firebase/functions";
import "firebase/firestore";

import { Collapse, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Grid, Button, Chip } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MediaQuery from "react-responsive";
import { useMediaQuery } from "react-responsive";

import NoReviews from "../../NoReviews";
import ReviewForm from "../../../../Components/ReviewForm";
import StarWidgetReadOnly from "../../../../Components/StarWidgetReadOnly";
import Review from './Review';

class Reviews extends Component {
  constructor(props) {
    super(props);
    ReactGA.pageview(`company/${this.props.companyName}/reviews`);
    this.state = {
      reviewForm: false,
      loading: true,
    };
  }

  toggleForm = () => this.setState({ reviewForm: !this.state.reviewForm });

  renderReviews = () => {
    const { reviewForm } = this.state;

    if (reviewForm) return null;

    const { reviews, classes, companyImage } = this.props;

    if (!reviews.details) {
      return null;
    }

    if (reviews.details.length) {
        return (
            <>
                {reviews.details.map((review) => <Review review={review} />)}
            </>
        )
    } else {
        return null;
    }
  };

  render() {
    const {
      currentSubpage,
      companyName,
      setSubpage,
      initialLoad,
      reviews,
      classes,
    } = this.props;
    const { reviewForm, loading } = this.state;

    let avgRating = [];

    let scoreSum = 0;
    let avgScore = 0;

    if (reviews && reviews.details) {
      reviews.details.forEach((review) => (scoreSum += review.rating));
      avgScore = scoreSum / reviews.details.length;
    }

    if (initialLoad) {
      return (
        <Grid
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "100px",
          }}
        >
          <CircularProgress />
        </Grid>
      );
    }

    return (
      <>
        <Grid container>
          <Grid item xs={12}>
            {!(!reviews.details || reviews.details.length === 0) && (
              <ReviewButton
                toggleForm={this.toggleForm}
                reviewForm={reviewForm}
                className={classes.reviewButtonContainer}
                avgScore={avgScore}
              />
            )}
            <Collapse in={!reviewForm}>
              {(!reviews.details || reviews.details.length === 0) && (
                <NoReviews
                  openForm={this.toggleForm}
                  companyName={companyName}
                />
              )}
              {reviews.details && this.renderReviews()}
            </Collapse>
            <Collapse in={reviewForm}>
              <ReviewFormLayout
                companyName={companyName}
                toggleForm={this.toggleForm}
              />
            </Collapse>
          </Grid>
        </Grid>
      </>
    );
  }
}

function ReviewFormLayout({ companyName, toggleForm }) {
  const [mobileSubmitComplete, setMobileSubmitComplete] = React.useState(false);
  const [mobileSubmitting, setMobileSubmitting] = React.useState(false);

  const setSubmitting = () => setMobileSubmitting(true);

  const submitComplete = () => {
    setMobileSubmitting(false);
    setMobileSubmitComplete(true);
  };

  const resetMobileForm = () => {
    setMobileSubmitting(false);
    setMobileSubmitComplete(false);
  };

  const isMobile = useMediaQuery({
    query: "(max-device-width: 700px)",
  });

  if (mobileSubmitComplete) {
    return (
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Typography style={{ fontWeight: "bold" }}>
          Submission Complete
        </Typography>
        {/* <Button onClick={resetMobileForm}>Ok</Button>  */}
      </div>
    );
  }

  if (isMobile) {
    return (
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        <ReviewForm
          companyName={companyName}
          containerStyle={{ paddingTop: "30px" }}
          isMobile={true}
          toggleForm={toggleForm}
          submitComplete={submitComplete}
        />
      </div>
    );
  }

  return <ReviewForm companyName={companyName} />;
}



function ReviewButton({ toggleForm, reviewForm, classes, avgScore }) {
  const isMobile = useMediaQuery({
    query: "(max-width: 700px)",
  });

  let centerStyle = isMobile
    ? { marginLeft: "auto", marginRight: "auto", marginTop: "30px" }
    : {};

  const doToggle = isMobile
    ? () => {
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: "auto",
        });
        toggleForm();
      }
    : toggleForm;

  const containerStyle = isMobile
    ? {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: "5px",
      }
    : {};
  const starContainer = isMobile
    ? { position: "relative", top: "-100px", left: "-13px" }
    : {};

  if (reviewForm) {
    return (
      <Grid justify="space-between" xs={12} style={containerStyle}>
        <Grid
          style={{
            marginBottom: "-23px",
            marginLeft: "30px",
            ...starContainer,
          }}
        >
          <StarWidgetReadOnly rating={avgScore} showNumber />
        </Grid>
        <Button
          variant="contained"
          color="default"
          style={{
            display: "flex",
            marginBottom: "15px",
            marginLeft: "auto",
            marginRight: "32px",
            ...centerStyle,
          }}
          onClick={toggleForm}
        >
          Close Form
        </Button>
      </Grid>
    );
  }

  return (
    <Grid justify="space-between" xs={12} style={containerStyle}>
      <Grid
        style={{ marginBottom: "-23px", marginLeft: "30px", ...starContainer }}
      >
        <StarWidgetReadOnly rating={avgScore} showNumber />
      </Grid>
      <Button
        variant="contained"
        color="default"
        startIcon={<AddCircleOutlineIcon />}
        style={{
          display: "flex",
          marginBottom: "15px",
          marginLeft: "auto",
          marginRight: "32px",
          ...centerStyle,
        }}
        onClick={doToggle}
      >
        Add Review
      </Button>
    </Grid>
  );
}


const styles = (theme) => ({
  formControl: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  "@media (max-width: 700px)": {
    formControl: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
});

export default withStyles(styles)(Reviews);